module.exports = __webpack_public_path__ + "static/media/semiTractorWithTrailer_yellow.f62635ff.svg";